import React from 'react'
import PropTypes from 'prop-types'

import GridLayout from 'Components/GridLayout'
import TableLayout from 'Components/TableLayout'

const LayoutManager = props => {
  const { handleSort, layout, rugs, searchForm, sortBy, sortOrder, togglePreview, toggleSortOrder, user } = props

  return rugs.length > 0 ? (
    <div>
      {layout === 'gridLayout' && <GridLayout rugs={rugs} searchForm={searchForm} togglePreview={togglePreview} enablePreview />}

      <br />

      {layout === 'tableLayout' && (
        <TableLayout
          rugs={rugs}
          handleSort={handleSort}
          sortBy={sortBy}
          sortOrder={sortOrder}
          toggleSortOrder={toggleSortOrder}
          user={user}
        />
      )}
    </div>
  ) : null
}

LayoutManager.propTypes = {
  enablePreview: PropTypes.bool,
  handleSort: PropTypes.func.isRequired,
  layout: PropTypes.string.isRequired,
  rugs: PropTypes.array.isRequired,
  searchForm: PropTypes.bool.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  togglePreview: PropTypes.func,
  toggleSortOrder: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default LayoutManager
